export enum Platform {
    Youtube = 'youtube',
    Vimeo = 'vimeo',
    Instagram = 'instagram',
    Tiktok = 'tiktok'
};

